export default __webpack_public_path__ + "src/images/text_sidebar/4-48ba7e.png";